module.exports = __webpack_public_path__ + "static/pic04-ad6cee03f61896190f05ca62b258866e.jpg";